// src/models/Feedback.js
import excuseApi from '../api/excuseApi';

const Feedback = {
  async createFeedback(data) {
    return await excuseApi({
      endpoint: '/feedback',
      method: 'POST',
      data,
    });
  },
  async getAllFeedback() {
    return await excuseApi({
      endpoint: '/feedback',
      method: 'GET',
    });
  },
};

export default Feedback;
